import { render, staticRenderFns } from "./FormDocument.vue?vue&type=template&id=7e7b4e52&scoped=true"
import script from "./FormDocument.vue?vue&type=script&lang=js"
export * from "./FormDocument.vue?vue&type=script&lang=js"
import style0 from "./FormDocument.vue?vue&type=style&index=0&id=7e7b4e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7b4e52",
  null
  
)

export default component.exports